import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { BasicModalV2, TextButton } from '../../../../components/index.js';
import CustomModalHeader from '../../../Common/customComponents/CustomModalHeader.tsx';

import { useAsync, useUser } from '../../../../hooks/index.js';
import CustomText from 'containers/Common/customComponents/CustomText.tsx';
import { ptwApi } from '../../../../api/ptw.api.ts';
import CustomTextarea from 'containers/Common/customComponents/CustomTextarea.tsx';
import { commonMsg } from 'utils/globalUtil.tsx';
import _ from 'lodash';
import CustomDatetime from 'containers/Common/customComponents/CustomDatetime.tsx';
import OperatorModal from './OperatorModal.tsx';
import FormTabXBlack from '/assets/icon/global/form-tab-x-black.svg';

interface IProps {
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  isModalOpen: boolean;
  title: string;
  ptwDSeq: number;
  onActionCallback: any;
  validStartTime: string;
  validEndTime: string;
}

const PermitExtendModal = (props: IProps) => {
  const { showAlarm, closeAlarm } = useAsync();
  const [data, setData] = useState<any>({});
  const [coordinator, setCoordinator] = useState<any[]>([]);
  const [isOperatorModalOpen, setIsOperatorModalOpen] = useState(false);
  const user = useUser();

  const modalClose = () => {
    props.setIsModalOpen(false);
  };

  const handleChange = (e: any) => {
    setData((prev: any) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  useEffect(() => {
    if (!props.isModalOpen) {
      setData({});
      setCoordinator([]);
      return;
    }
    if (!props.validStartTime || !props.validEndTime) return;

    setData((prev: any) => ({
      ...prev,
      extenderId: user.userInfo?.userId,
      ptwDSeq: props.ptwDSeq,
      validStartTime: props.validStartTime,
      validEndTime: props.validEndTime
    }));
  }, [props.isModalOpen, props.ptwDSeq, props.validStartTime, props.validEndTime]);

  const onCoordinatorCallback = (checkedList: any[]) => {
    if (!checkedList) return;
    setCoordinator(checkedList.map((v: any) => ({ userId: v.userId, userNm: v.userNm })));
    commonMsg.alert(showAlarm, closeAlarm, 'Success', 'It has been Added.', null);
  };

  const deleteCoordinator = (userId: string) => {
    setCoordinator((prev) => prev.filter((c) => c.userId !== userId));
  };

  //ok
  const save = () => {
    if (coordinator.length === 0) {
      commonMsg.alert(showAlarm, closeAlarm, 'Warning', 'Please add a PTW Coordinator.', null);
      return;
    }
    let formData = _.cloneDeep({ ...data, coordinator });
    commonMsg.confirm(
      showAlarm,
      closeAlarm,
      'Confirm',
      'Would you like to extend this Permit?',
      () => {
        ptwApi.extend(formData).then(async (r) => {
          if (!r.isSuccess) {
            commonMsg.alert(showAlarm, closeAlarm, 'Error', 'Error', null);
            return;
          }
          commonMsg.alert(showAlarm, closeAlarm, 'Success', 'Extended successfully', () => {
            props.onActionCallback();
            modalClose();
          });
        });
      }
    );
  };

  const onReset = () => {
    setData((prev: any) => ({
      ...prev,
      comment: ''
    }));
  };

  return (
    <BasicModalV2 open={props.isModalOpen} onClose={() => props.setIsModalOpen(false)}>
      <CustomModalHeader title={props.title} modalClose={modalClose} />
      <OperatorModal
        setIsModalOpen={setIsOperatorModalOpen}
        isModalOpen={isOperatorModalOpen}
        title={'Ptw Coordinator'}
        onActionCallback={onCoordinatorCallback}
        selectedList={coordinator}
      />
      <div
        className={'custom-modal-body permit-cancel-modal'}
        style={{ width: '700px', height: '520px' }}
      >
        <div className={'contents-box'}>
          <div className={'header-title'}>* Name</div>
          <div style={{ width: '100%' }}>
            <CustomText
              name={'extendName'}
              className={'form'}
              onChange={handleChange}
              value={data?.extendName}
              readOnly={true}
              defaultValue={user.userInfo?.fullName}
            />
          </div>

          <div className={'header-title'}>* Expected Work Duration</div>
          <div style={{ width: '100%', display: 'flex', gap: '10px' }}>
            <CustomDatetime
              key={data?.validStartTime}
              name={'validStartTime'}
              className={'form'}
              onChange={handleChange}
              value={data?.validStartTime}
              disabled
            />
            <span>-</span>
            <CustomDatetime
              key={data?.validEndTime}
              name={'validEndTime'}
              className={'form'}
              onChange={handleChange}
              value={data?.validEndTime}
            />
          </div>

          <div className={'header-title'}>* PTW Coordinator</div>
          <div style={{ width: '100%' }}>
            <CustomText
              name={'coordinator'}
              className={'form'}
              value={coordinator.map((c) => c.userNm).join(', ')}
              isBtnSearch={true}
              onSearchAction={() => setIsOperatorModalOpen(true)}
            />
            <div className="work-select-multi">
              {coordinator.map((item, index) => (
                <div className="selected-item" key={index}>
                  <span>{item.userNm}</span>
                  <a onClick={() => deleteCoordinator(item.userId)}>
                    <img
                      src={FormTabXBlack}
                      alt="close"
                      style={{ width: '15px', height: '15px' }}
                    />
                  </a>
                </div>
              ))}
            </div>
          </div>

          <div className={'cancel-header'}>
            <span className={'header-title'}>* Comment</span>
            <button className="header-btn" onClick={onReset}>
              Reset
            </button>
          </div>
          <div style={{ width: '100%', height: '100%' }}>
            <CustomTextarea
              name={'comment'}
              className={'form'}
              onChange={handleChange}
              value={data?.comment}
              isReload={true}
            />
          </div>
          <div className={'button-box'}>
            <TextButton
              className={'cancel-style'}
              variant="outlined"
              style={{ height: '40px' }}
              onClick={modalClose}
            >
              Close
            </TextButton>

            <TextButton variant="contained" style={{ height: '40px' }} onClick={save}>
              OK
            </TextButton>
          </div>
        </div>
      </div>
    </BasicModalV2>
  );
};

export default PermitExtendModal;
